/**
 * The initial values for the redux state.
 */
export default {
  timestamp: 0,
  userId: 0,
  documents: [],
  fetchIsLoading: false,
  sorts: {
    id: 'descend'
  },
  filters: {},
  pageSize: '20',
  currentPage: 1,
  lastPage: 10,
  total: 0,

  expandedRows: []
};
